var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGavel2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80762 20.5868H12.8076C13.3576 20.5868 13.8076 21.0368 13.8076 21.5868C13.8076 22.1368 13.3576 22.5868 12.8076 22.5868H2.80762C2.25762 22.5868 1.80762 22.1368 1.80762 21.5868C1.80762 21.0368 2.25762 20.5868 2.80762 20.5868ZM6.04762 7.65684L8.87762 4.82684L21.6076 17.5568C22.3876 18.3368 22.3876 19.6068 21.6076 20.3868C20.8276 21.1668 19.5576 21.1668 18.7776 20.3868L6.04762 7.65684ZM14.5376 1.99684L17.3676 4.82684C18.1476 5.60684 18.1476 6.87684 17.3676 7.65684L15.9476 9.07684L10.2976 3.41684L11.7076 2.00684C12.4876 1.21684 13.7576 1.21684 14.5376 1.99684ZM4.63762 9.06684L10.2976 14.7268L8.88762 16.1368C8.10762 16.9168 6.83762 16.9168 6.05762 16.1368L3.22762 13.3068C2.44762 12.5268 2.44762 11.2568 3.22762 10.4768L4.63762 9.06684Z",
    fill: "#4A0DFB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGavel2);
export default __webpack_public_path__ + "static/media/gavel2.8a324e4574220d27a4ef153dda751c0f.svg";
export { ForwardRef as ReactComponent };